import React, { useState, useEffect } from 'react';
import {
  Container,
  DivFooter,
  ContainerSearch,
  ContainerItem,
  Search,
  CopyGroup,
  Copy,
  Policy,
  WhatsappFloat,
} from './styles';
import needHelpSvg from '../../static/img/need-help-footer.svg';
import { ReactComponent as WhatsappFloatIcon } from '../../static/img/whatsapp_float.svg';
import { Actions, Categories } from '../../types/gtm';
import { useAuth } from '../../hooks/useAuth';
import { ReactComponent as SearchIcon } from '../../static/img/search-icon.svg';

const Footer = () => {
  const [searchParam, setSearchParam] = useState<string>('');
  const { user, homeInfo } = useAuth();
  const [isAccountB2B, setAccountB2B] = useState<boolean>(false);

  const redirectSearch = () => {
    if (searchParam) {
      window.open(
        `https://ajuda.globo.com/s/global-search/${searchParam}?`,
        '_blank',
      );
    }
    return null;
  };

  const actualYear = new Date().getFullYear();
  const acessDate = `Dia: ${new Date().getDate()} / ${
    new Date().getMonth() + 1
  } - Horário: ${new Date().getHours()} : ${new Date().getMinutes()}`;

  useEffect(() => {
    if (homeInfo?.componentAccountInfoB2B) {
      setAccountB2B(!!homeInfo?.componentAccountInfoB2B?.data?.globoId);
    }
  }, [homeInfo]);

  return (
    <DivFooter>
      <Container>
        <ContainerSearch>
          <ContainerItem>
            <Search>
              <div className="mcv3-search-input">
                <input
                  name="search"
                  id="search"
                  placeholder="Ainda precisa de ajuda? Digite sua dúvida"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setSearchParam(e.target.value)
                  }
                  autoComplete="off"
                />

                <button
                  type="button"
                  className="mcv3-circle-icon"
                  onClick={redirectSearch}
                >
                  <SearchIcon title="search" aria-label="search" />
                </button>
              </div>
            </Search>
          </ContainerItem>
          <ContainerItem>
            <div>
              <a
                href="https://ajuda.globo.com/s/"
                target="_blank"
                rel="noreferrer"
              >
                <span>
                  <img src={needHelpSvg} alt="" />
                </span>
                {isAccountB2B ? 'Ajuda Globo' : 'Acessar Ajuda'}
              </a>
            </div>

            {isAccountB2B ? (
              <div>
                <a
                  href="https://ajuda.globoads.globo.com/s/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>
                    <img src={needHelpSvg} alt="" />
                  </span>
                  Ajuda Globo Ads
                </a>
              </div>
            ) : null}
          </ContainerItem>
        </ContainerSearch>
        <CopyGroup>
          <Copy>
            {`© Copyright 2000-${actualYear} Globo Comunicação e Participações S.A`}
          </Copy>
          <Policy
            href={
              user?.privacyPolicy?.url ||
              'http://www.globo.com/privacidade.html'
            }
            target="_blank"
          >
            Aviso de privacidade
          </Policy>
        </CopyGroup>
      </Container>
      <WhatsappFloat>
        <a
          href="http://glo.bo/4kjqn0l"
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.Footer,
              event_action: Actions.ClickWhatsApp,
              event_label: `Info: ${acessDate}`,
              bd_suser_code: user?.globoId,
            });
          }}
        >
          <WhatsappFloatIcon />
        </a>
      </WhatsappFloat>
    </DivFooter>
  );
};

export default Footer;
